import { Input } from 'antd';

/**
 * Тохиргооны хуудсанд мэдээллийг зөвхөн харах input хэлбэрээр үзүүлэх нийтлэг хэсэг.
 * Бүртгэлийн мэдээлэл, Гэрээ гэсэн табууд нэг ижил харагдахын тулд энд төвлөрүүлэв.
 */

/** Талбарын дүрсний өнгө — бусад формтой ижил сааралдуу өнгө */
export const ICON_COLOR = '#626F86';

/** Input хэт сунахаас сэргийлэх дээд өргөн (хаяг мэтийн урт талбарт 2 дахин) */
export const FIELD_MAX_WIDTH = 320;

/** Багана хоорондын зай */
export const FIELD_GAP = 24;

/** Баганууд зүүн талдаа шахагдаж, үлдсэн зай нь баруун талд үлдэнэ */
export const GRID_MAX_WIDTH = (FIELD_MAX_WIDTH + FIELD_GAP) * 3;

/** Хоосон утгыг "-" болгож харуулна */
export const val = (value) => (value === null || value === undefined || value === '' ? '-' : value);

/** Descriptions-ийн ерөнхий тохиргоо: label дээр, value доор, зүүн талдаа шахагдсан */
export const descriptionProps = {
  size: 'small',
  colon: false,
  layout: 'vertical',
  column: { xs: 1, sm: 2, xl: 3 },
  labelStyle: { paddingBottom: 4 },
  contentStyle: { paddingBottom: 12, paddingRight: FIELD_GAP },
  style: { maxWidth: GRID_MAX_WIDTH },
};

/** Талбарын утга: зөвхөн харах input, урд нь дүрс. `wide` — олон баганад сунах талбар */
const FieldInput = ({ icon: Icon, value, wide }) => (
  <Input
    readOnly
    value={val(value)}
    prefix={<Icon size={16} style={{ color: ICON_COLOR }} />}
    style={{ cursor: 'default', maxWidth: wide ? FIELD_MAX_WIDTH * 2 : FIELD_MAX_WIDTH }}
  />
);

export default FieldInput;
